/* Oracle Horizon header: mega menu, mobile drawer, sticky, cart count */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initHeader(root) {
    if (root.dataset.ohhBooted) return;
    root.dataset.ohhBooted = 'true';

    var overlay = root.querySelector('[data-ohh-overlay]');
    var drawer = root.querySelector('[data-ohh-drawer]');
    var openDelay = parseInt(root.dataset.hoverDelay, 10);
    if (isNaN(openDelay)) openDelay = 120;

    /* ---------------- Desktop mega menu ---------------- */

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ohh-has-children]'));
    var openTimer = null;
    var closeTimer = null;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var trigger = item.querySelector('.ohh-nav__link');
        if (trigger && trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'false');
      });
      if (!except && overlay) overlay.classList.remove('is-visible');
    }

    function open(item) {
      closeAll(item);
      item.classList.add('is-open');
      var trigger = item.querySelector('.ohh-nav__link');
      if (trigger && trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'true');
      if (overlay && item.querySelector('.ohh-mega')) overlay.classList.add('is-visible');
    }

    function close(item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.ohh-nav__link');
      if (trigger && trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-visible');
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(function () {
          open(item);
        }, openDelay);
      });

      item.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(function () {
          close(item);
        }, 140);
      });

      var trigger = item.querySelector('.ohh-nav__link');
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          if (item.classList.contains('is-open')) {
            close(item);
          } else {
            open(item);
          }
        });
      }

      item.addEventListener('focusin', function () {
        open(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
        if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });

    /* ---------------- Mobile drawer ---------------- */

    var lastFocus = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      if (overlay) overlay.classList.add('is-visible', 'is-top');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible', 'is-top');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-ohh-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    root.querySelectorAll('[data-ohh-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDrawer();
        closeAll();
      });
    }

    if (drawer) {
      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var nodes = Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE)).filter(function (n) {
          return n.offsetParent !== null;
        });
        if (!nodes.length) return;
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    /* ---------------- Mobile accordions ---------------- */

    root.querySelectorAll('[data-ohh-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (root.dataset.accordionSingle === 'true' && !isOpen) {
          root.querySelectorAll('[data-ohh-acc][aria-expanded="true"]').forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var op = document.getElementById(other.getAttribute('aria-controls'));
            if (op) op.hidden = true;
          });
        }

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });

    /* ---------------- Sticky ---------------- */

    if (root.classList.contains('ohh--sticky')) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
      if (root.parentNode) root.parentNode.insertBefore(sentinel, root);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            root.classList.toggle('is-stuck', !entries[0].isIntersecting);
          },
          { threshold: 0 }
        ).observe(sentinel);
      }
    }

    /* ---------------- Search field state ---------------- */

    root.querySelectorAll('[data-ohh-search]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="search"], input[name="q"]');
      var reset = wrap.querySelector('[data-ohh-search-reset]');
      if (!input) return;
      function sync() {
        wrap.classList.toggle('is-filled', input.value.length > 0);
      }
      input.addEventListener('input', sync);
      if (reset) {
        reset.addEventListener('click', function () {
          input.value = '';
          sync();
          input.focus();
        });
      }
      sync();
    });

    /* ---------------- Cart count ---------------- */

    function paintCount(count) {
      root.querySelectorAll('[data-ohh-cart-count]').forEach(function (el) {
        el.textContent = count > 99 ? '99+' : String(count);
        el.hidden = count < 1;
      });
    }

    function refreshCart() {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          paintCount(cart.item_count);
        })
        .catch(function () { /* leave server-rendered count */ });
    }

    document.addEventListener('cart:refresh', refreshCart);
    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart-drawer:open', refreshCart);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ohh-root]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  window.ohhBoot = boot;
})();
